import React from 'react';
import { ZapIcon, TrendingUpIcon } from 'lucide-react';
const ImpactMetrics = () => {
  return <section className="w-full bg-slate-900 py-16 border-y border-slate-800" data-id="element-242">
      <div className="container mx-auto px-4" data-id="element-243">
        <div className="grid md:grid-cols-2 gap-8 max-w-4xl mx-auto" data-id="element-244">
          <div className="text-center" data-id="element-245">
            <div className="flex justify-center mb-4" data-id="element-246">
              <div className="bg-orange-500/10 p-4 rounded-lg" data-id="element-247">
                <ZapIcon size={32} className="text-orange-500" data-id="element-248" />
              </div>
            </div>
            <h3 className="text-4xl font-bold text-white mb-2" data-id="element-249">
              Up to <span className="text-orange-500" data-id="element-250">95%</span>
            </h3>
            <p className="text-lg font-semibold text-white mb-2" data-id="element-251">
              faster form completion
            </p>
            <p className="text-slate-400" data-id="element-252">
              with multi-modal inputs and AI assisted form filling.
            </p>
          </div>
          <div className="text-center" data-id="element-253">
            <div className="flex justify-center mb-4" data-id="element-254">
              <div className="bg-orange-500/10 p-4 rounded-lg" data-id="element-255">
                <TrendingUpIcon size={32} className="text-orange-500" data-id="element-256" />
              </div>
            </div>
            <h3 className="text-4xl font-bold text-white mb-2" data-id="element-257">
              Up to <span className="text-orange-500" data-id="element-258">30%</span>
            </h3>
            <p className="text-lg font-semibold text-white mb-2" data-id="element-259">
              higher completion rates
            </p>
            <p className="text-slate-400" data-id="element-260">
              with interactive multi-channel forms (Whatsapp, Slack).
            </p>
          </div>
        </div>
      </div>
    </section>;
};
export default ImpactMetrics;